import { CurrencyPair } from "@/generated/TradingGateway"
import {
  customNumberFormatter,
  DECIMAL_SEPARATOR,
  significantDigitsNumberFormatter,
} from "@/utils"
import { join } from "@/utils/join"

import { PriceButtonVariant } from "./types"

const formatSimple = customNumberFormatter()
const formatTo2Digits = significantDigitsNumberFormatter(2)
const formatTo3Digits = significantDigitsNumberFormatter(3)
const formatToMin2IntDigits = customNumberFormatter({
  minimumIntegerDigits: 2,
})

interface PriceProps {
  currencyPair: CurrencyPair
  price: number
  variant: PriceButtonVariant
}

export const PriceButtonPrice = ({
  currencyPair,
  price,
  variant,
}: PriceProps) => {
  const { pipsPosition, ratePrecision } = currencyPair
  const rateString = price.toFixed(ratePrecision)
  const [wholeNumber, fractions_] = rateString.split(".")
  const fractions = fractions_ || "00000"

  const pip = formatToMin2IntDigits(
    Number(fractions.substring(pipsPosition - 2, pipsPosition)),
  )
  const tenth = formatSimple(
    Number(fractions.substring(pipsPosition, pipsPosition + 1)),
  )
  const bigFigureNumber = Number(
    wholeNumber + "." + fractions.substring(0, pipsPosition - 2),
  )

  let bigFigure =
    bigFigureNumber < 1 && pipsPosition === 4
      ? formatTo2Digits(bigFigureNumber)
      : formatTo3Digits(bigFigureNumber)

  if (bigFigureNumber === Math.floor(bigFigureNumber))
    bigFigure += DECIMAL_SEPARATOR

  const colorClasses: Record<PriceButtonVariant, string> = {
    primary: "text-inherit",
    active: "text-inherit",
    pending: "text-inherit",
    priceAnnounced: "text-inherit",
    disabled: "text-disabled",
  }

  return (
    <div className={join(colorClasses[variant], "tabular-nums")}>
      <p className="inline text-sm-regular">{price ? bigFigure : "-"}</p>
      {price && (
        <>
          <h2 className="inline display-xl-regular leading-5xl">{pip}</h2>
          <p className="inline text-sm-regular">{tenth}</p>
        </>
      )}
    </div>
  )
}
